import { Layout } from "widgets"
import { belowViewPort } from "utils"
import { ImageButton } from "widgets"
import resbirdLogo from "images/resbird-logo.svg"

const Footer = () => (
  <Layout
    className="app-footer"
    css={[
      {
        padding: "22px 20px",
        gap: 40,
        fontSize: "1rem",
        fontWeight: 400,
        flexWrap: "wrap",
        flexShrink: 0,
        width: "100%",
        zIndex: 110,
      },
      belowViewPort(1167, { flexFlow: "column", padding: 12 }),
      belowViewPort(1441, { fontSize: "0.75rem" }),
    ]}
  >
    <ImageButton
      className="logo-button"
      alt="Resbird Technologies"
      icon={resbirdLogo}
      css={[
        {
          width: "max-content",
          textAlign: "left",
          height: 16,
        },
        belowViewPort(768, {
          height: 15,
        }),
      ]}
      iconStyle={{
        height: 16,
        ...belowViewPort(1441, {
          height: 15,
        }),
      }}
    />
    <Layout
      css={[
        belowViewPort(953, { justifyContent: "space-between", width: "100%" }),
        {
          gap: 40,
          flexWrap: "wrap",
          flexGrow: 2,
          justifyContent: "center",
          ">a": { textDecoration: "none", color: "black" },
        },
      ]}
    >
      <a
        aria-describedby="About Us"
        rel="noreferrer"
        href="https://www.resbird.tech/about-us/"
        target="_blank"
        className="about-us"
      >
        {t("footer.about_us")}
      </a>
      <a
        aria-describedby="Contact Us"
        rel="noreferrer"
        href="https://www.resbird.tech/contact/"
        target="_blank"
        className="contact-us"
      >
        {t("footer.contact_us")}
      </a>
      <a
        aria-describedby="Privacy Policy"
        rel="noreferrer"
        href="https://www.resbird.tech/privacy-policy/"
        target="_blank"
        className="privacy-policy"
      >
        {t("footer.privacy_policy")}
      </a>
      <a
        aria-describedby="Terms and Conditions"
        rel="noreferrer"
        href="https://www.resbird.tech/terms-and-conditions/"
        target="_blank"
        className="terms-and-conditions"
      >
        {t("footer.terms_and_conditions")}
      </a>

      <a
        aria-describedby="Refund and Cancellation Policy"
        rel="noreferrer"
        href="https://www.resbird.tech/refund-and-cancellation-policy/"
        target="_blank"
        className="refund-and-cancellation-policy"
      >
        {t("footer.refund_and_cancellation_policy")}
      </a>
    </Layout>
    <div
      className="copyright-container"
      css={belowViewPort(953, { textAlign: "center" })}
    >
      {t("footer.copyright")}
    </div>
  </Layout>
)

export default Footer
